'use client';

import { useLayoutEffect, useRef } from 'react';

// Server-rendered catch-all canonical (CON-8824). Bots get a blocking render,
// so React hoists it into <head> in their raw HTML. Browsers get the PPR shell,
// so it streams into <body> and hydrates in place; the effect moves it to
// <head>.
//
// Next keeps the previous route mounted but hidden after a client navigation,
// so the cleanup detaches the tag to avoid two canonicals. It parks it in a
// fragment instead of removing it, because React unmounts it with
// parentNode.removeChild.
const CanonicalLink = ({ href }) => {
  const linkRef = useRef(null);

  useLayoutEffect(() => {
    const link = linkRef.current;

    if (!link) return undefined;

    document.head.appendChild(link);

    return () => {
      document.createDocumentFragment().appendChild(link);
    };
  }, []);

  return <link ref={linkRef} rel="canonical" href={href} />;
};

export default CanonicalLink;
